import { FC } from "react";

import SearchColumnDropdownPicker from "./SearchInput/SearchColumnDropdownPicker";
import SearchInput from "./SearchInput/SearchInput";

interface SearchBarProps {
  hasSearchColumnDropdownPicker?: boolean;
}

const SearchBar: FC<SearchBarProps> = ({ hasSearchColumnDropdownPicker = true }) => {
  return (
    <div className="option_header">
      <SearchInput></SearchInput>
      {hasSearchColumnDropdownPicker && <SearchColumnDropdownPicker />}
    </div>
  );
};

export default SearchBar;
